const cn = {
  link: {
    enter_link_title_en: "输入链接标题",
    enter_link: "输入链接",
    add_icon: "添加图标",
    save_cap: "节省",
    delete_cap: "删除",
    link_cap: "链接",
    add: "添加",
    edit: "编辑",
    link_is_required: "链接标题是必填项",
    link_url_required: "链接URL是必填项",
    select_lang: "选择语言",
  },
  avatar: {
    save_cap: "节省",
    delete_cap: "删除",
    add: "添加",
    edit: "编辑",
    avatar: "头像",
    drop_your_img: "将您的图像拖到此处或",
    browse_image: "浏览图像",
    maximum: "最大限度",
    choose_another: "选择其他",
    size: "尺寸",
    select_lang: "选择语言",
    shape: "形状",
  },
  qr_code: {
    save_cap: "节省",
    delete_cap: "删除",
    add: "添加",
    edit: "编辑",
    select_lang: "选择语言",
    Qr_code: "QR 码",
  },

  texteditor: {
    save_cap: "节省",
    delete_cap: "删除",
    add: "添加",
    edit: "编辑",
    select_lang: "选择语言",
    text: "文本",
  },

  faq: {
    faq: "常见问题解答",
    add_faq: "添加常见问题",
    question_required: "需要问题",
    answer_required: "需要答案",
    enter_question: "输入问题",
    enter_answer: "输入答案",
    save_cap: "节省",
    delete_cap: "删除",
    select_lang: "选择语言",
    add: "添加",
    edit: "编辑",
  },
  media: {
    add: "添加",
    edit: "编辑",
    enter_link: "输入链接",
    save_cap: "节省",
    delete_cap: "删除",
    select_lang: "选择语言",
  },
  image: {
    image: "图像",
    add: "添加",
    select_lang: "选择语言",
    edit: "编辑",
    drop_your_img: "将您的图像拖到此处或",
    browse_image: "浏览图像",
    choose_another: "选择其他",
    maximum: "最大限度",
    description: `描述`,
    enter_alt_text: "输入ALT文本",
    save_cap: "节省",
    delete_cap: "删除",
  },
  imagegrid: {
    add_image_grid: "添加图像网格",
    maximum: "最大限度",
    drop_your_img: "将您的图像拖到此处或",
    browse_image: "浏览图像",
    save_cap: "节省",
    select_lang: "选择语言",
    add: "添加",
    edit: "编辑",
    delete_cap: "删除",
    image_grid: "图像网格",
  },
  divider: {
    divider: "分隔线",
    add_divider: "添加分隔线",
    color: "颜色",
    select_lang: "选择语言",
    add: "添加",
    edit: "编辑",
    divider_cap: "分隔符",
    save_cap: "节省",
    delete_cap: "删除",
  },
  addcountdown: {
    countdown: "倒计时",
    add_countdown: "添加倒计时器",
    enter_countdown_description: "输入倒计时描述",
    choose_time: "选择时间",
    choose_date: "选择日期",
    timer_digit_color: "计时器数字颜色",
    timer_background_color: "计时器背景颜色",
    save_cap: "节省",
    delete_cap: "删除",
    select_lang: "选择语言",
    edit_countdown: "编辑倒计时器",
  },
  header: {
    header: "标题",
    add_header: "添加标题",
    enter_page_name: "输入页面名称",
    enter_page_title: "输入页面标题",
    pagename_required: "页面名称必填",
    pagetitle_required: "页面标题必填",
    contact_required: "联系方式必填",
    edit_header: "编辑标题",
    whatapp_required: "需要Whatsapp",
    whatapp: "Whatsapp",
    profile_alignment: "轮廓对齐",
    left: "左边",
    center: "中心",
    right: "正确的",
    want_to_set_background_image: "想要设置背景图像",
    avatar_size: "头像尺寸",
    avatar_shape: "头像形状",
    avatar_outline: "头像轮廓",
    image_smaller_than_3MB: "图像必须小于3MB",
    select_lang: "选择语言",
    save_cap: "节省",
    delete_cap: "删除",
    choose_avatar: "选择头像",
    contact: "接触",
    maximum: "最大限度",
    drop_your_img: "将您的图像拖到此处或",
    browse_image: "浏览图像",
    choose_another: "选择其他",
    yes: "是",
    no: "否",
    circle: "圆形",
    corners: "角",
    rounded: "圆角",
    straight: "直角",
    color: "颜色",
  },
  socials: {
    socials: "社交媒体",
    save_cap: "节省",
    delete_cap: "删除",
    select_lang: "选择语言",
    add: "添加",
    edit: "编辑",
    enter: "输入",
  },
  
  location: {
    addpin: '添加标记',
    cancel_adding_pin: '取消添加标记',
    adress: '地址',
    adress_placeholder: '123 Main St, City',
    phone: '电话',
    phone_placeholder: '123-456-7890',
    add_location: '添加位置',
    set_primary: '设为主要',
    primary_location: '主要位置',
    get_directions: '获取方向',
    added_any_location: '您尚未添加任何位置',
    adress_title_caps: '添加地址标题',
    adress_details_caps: '添加地址详情',
    enter_location_name: '输入位置名称',
    enter_location_adress: '输入位置地址',
    enter_location_phone: '输入位置电话',
    set_default_location: '将此位置设为您的主要/默认位置',
    home: '首页',
    save_cap: "节省",
    delete_cap: "删除",
    add_location: "添加位置",
    select_lang: "选择语言",
    edit_location: "编辑位置",
  },
  want_to_delete: '您确定要删除此项吗？',
  cancel: '取消',
  delete_cap: "删除",
};

export default cn;
